/*! Copyright (c) Safe As Milk. All rights reserved. */
import { recentHistory } from "./recent-search-history.js";
class RecentSearches extends HTMLElement {
    constructor() {
        super();
        this.onUpdate = () => this.update();
        this.onStorage = event => { if (event.key === null || recentHistory.keys.includes(event.key)) this.update(); };
        this.onClick = event => {
            const toggle = event.target.closest("[data-recent-toggle]");
            if (toggle && this.contains(toggle)) {
                event.preventDefault();
                recentHistory.setEnabled(!recentHistory.enabled());
                return;
            }
            const remove = event.target.closest("[data-recent-remove]");
            if (remove && this.contains(remove)) {
                event.preventDefault();
                recentHistory.remove(remove.dataset.recentRemove);
            }
        };
    }
    connectedCallback() {
        this.addEventListener("click", this.onClick);
        window.addEventListener("velkommen:recent-searches", this.onUpdate);
        window.addEventListener("storage", this.onStorage);
        window.addEventListener("focus", this.onUpdate);
        this.update();
    }
    disconnectedCallback() {
        this.removeEventListener("click", this.onClick);
        window.removeEventListener("velkommen:recent-searches", this.onUpdate);
        window.removeEventListener("storage", this.onStorage);
        window.removeEventListener("focus", this.onUpdate);
        clearTimeout(this.expiryTimer);
    }
    update() {
        const ul = this.querySelector("ul");
        const toggle = this.querySelector("[data-recent-toggle]");
        if (!ul || !toggle) return;
        const items = recentHistory.read();
        const enabled = recentHistory.enabled();
        toggle.setAttribute("aria-checked", String(enabled));
        this.parentElement?.classList.add("has-recent-searches");
        this.removeAttribute("hidden");
        const snapshot = JSON.stringify({ enabled, items });
        if (this.snapshot !== snapshot) {
            const focusedRow = ul.contains(document.activeElement) ? document.activeElement.closest("li") : null;
            const oldIndex = focusedRow ? Array.from(ul.children).indexOf(focusedRow) : -1;
            const fragment = document.createDocumentFragment();
            if (enabled) for (const item of [...items].reverse()) {
                const li = document.createElement("li");
                li.className = "search__nav-item recent-searches__item";
                const link = document.createElement("a");
                link.className = "search__nav-link";
                link.href = item.uri;
                link.textContent = item.query;
                const remove = document.createElement("button");
                remove.type = "button";
                remove.className = "recent-searches__remove";
                remove.dataset.recentRemove = item.query;
                remove.setAttribute("aria-label", `${item.query} ${this.dataset.removeLabel || ""}`.trim());
                const cross = document.createElement("span");
                cross.setAttribute("aria-hidden", "true");
                cross.textContent = "×";
                remove.append(cross);
                li.append(link, remove);
                fragment.append(li);
            }
            ul.replaceChildren(fragment);
            ul.hidden = !enabled || items.length === 0;
            this.snapshot = snapshot;
            if (oldIndex >= 0) {
                const target = ul.children[Math.min(oldIndex, ul.children.length - 1)]?.querySelector("a") || toggle;
                target.focus({ preventScroll: true });
            }
        }
        clearTimeout(this.expiryTimer);
        if (items.length) {
            const nextExpiry = Math.min(...items.map(item => item.searchedAt + recentHistory.week));
            this.expiryTimer = setTimeout(() => this.update(), Math.max(1, nextExpiry - Date.now() + 1));
        }
    }
}
if (!customElements.get("recent-searches")) customElements.define("recent-searches", RecentSearches);
